import { ChangeEvent } from 'react';

const onInputChange = (
  e: ChangeEvent<HTMLInputElement>,
  cb: Function,
) => cb(e.target.value);

export default onInputChange;
